import React from 'react'
import './MusicCard.css'
import GraySpotify from './img/gray_spotify.png'

function AlbumCard({image, title, release, description, release_link, sclink, unreleased, onsoundcloud}) {
    return (
        <div className='albumCard'>
                <a href={release_link}>  
                    <img className='albumCard_icon' src={image}/>
                </a>
              
                <div className="albumCard_info">
                <h1>{title}</h1>

                <p>Released On: {release}</p>
                <p>{description}</p>
                <p><a href={release_link}>
                <img className='linkicon' src={unreleased ? GraySpotify : 'https://cdn-icons-png.flaticon.com/512/174/174872.png' }/>
                
            </a></p>
            
            <p><a href={sclink}>
            <img className='linkicon2' src={onsoundcloud ? 'https://cdn2.iconfinder.com/data/icons/minimalism/512/soundcloud.png' : "" }/></a></p>
            </div>
            
        </div>
    )
}

export default AlbumCard
